import React from 'react';
import { Box } from '@mui/material';
import KpiTabs from './KpiTabs';

const KPIDashboard: React.FC = () => {
  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: 'background.default', width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
        }}
      >
        <KpiTabs />
      </Box>
    </Box>
  );
};

export default KPIDashboard;
